import { render, staticRenderFns } from "./PhotoReportModal.vue?vue&type=template&id=281b3f54&scoped=true&"
import script from "./PhotoReportModal.vue?vue&type=script&lang=js&"
export * from "./PhotoReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b3f54",
  null
  
)

export default component.exports